<template>
  <div id="club">
    <div class="club_context">
      <b>Клуб "Опцион LAFT" </b><br/><br/>объединяет единомышленников торговли
      опционами на бирже с образовательными, финансовыми и инвестиционными
      целями. <br />

      Команда клуба: Сергей Елисеев основатель терминала Option-lab и биржи
      крипто деривативов АЕ, опытные опционные трейдеры и специалисты команды
      LAFT. <br />

      Участник клуба получает доступы и сервисы: <br />

      <ul>
        <li class="marker_row">Закрытая группа Telegram</li>
        <li class="marker_row">Еженедельные вебинары с обзором опционных и алго стратегий</li>
        <li class="marker_row">
          Тематические вебинары по продвинутым темам обучения торговли опционами
          и алго трейдинга
        </li>
        <li class="marker_row">
          Разборы торговых стратегий участников с рекомендациями по управлению и
          контролю за рисками
        </li>
        <li  class="marker_row">Торговая и пользовательская поддержка в группе телеграм клуба</li>
        <li class="marker_row">Расширенный пакет торговых роботов</li>
        <li class="marker_row">
          Доступ к библиотеке вебинаров клуба в закрытом Telegram канале клуба
        </li>
      </ul>
    </div>
    <div class="club_context">
      <b>Условия участия в клубе </b> <br /> <br/>
      Первичная подписка 15 АЕ. Подписка в клуб полугодовая (6 месяцев). Стоимость продления подписки 9 АЕ (6 месяцев) . Ветеранам клуба стоимость продления 5 АЕ. (Ветеран - член клуба более года).
    </div>
    <div class="club_context">
      <b>Правила участия в клубе</b> <br />
      <ul>
        <li class="marker_row">
          Недопустимо выражение неуважения и оскорбления в отношении
          администрации или участников клуба.
        </li>
        <li class="marker_row">
          Нельзя заниматься продвижением в клубе собственных или сторонних услуг
          или сервисов.
        </li>
        <li class="marker_row">
          Запрещены публикации на ресурсах клуба политической, религиозной и др
          информации вне тематики трейдинга и криптовалют.
        </li>
        <li class="marker_row">
          Запрещена передача полученной в клубе информации и материалов третьим
        </li>
      </ul>
      За нарушения правил клуба следует исключение без возврата оплаты за
      подписку.<br />
      Администрация клуба оставляет за собой право отказа в принятии заявки на
      подписку.<br />
    </div>
    <div class="club_context" style="margin-bottom: 50px">
      <div class="mylabel">Имя Фамилия:</div>
      <div style="margin-top: 6px">
        <el-input v-model="fio" />
      </div>
      <div class="mylabel">Имя Telegram @:</div>
      <div style="margin-top: 6px">
        <el-input v-model="tele" />
      </div>
      <div class="mylabel">Комментарий:</div>
      <div style="margin-top: 6px">
        <el-input v-model="com" />
      </div>
      <div style="margin-top: 12px">
        <Button
          text="Заявка на подписку"
          @click="Send"
          :disabled="disabledButton"
        ></Button>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";
import Button from "./Button";
import { useMyStorage } from "../store/global";
import axios from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
export default defineComponent({
  name: "ClubComponent",
  components: {
    Button,
  },
  setup() {
    const store = useMyStorage();
    const disabledButton = ref(false);
    const fio = ref("");
    const tele = ref("");
    const com = ref("");
    const Send = () => {
      disabledButton.value = true;
      const msg = ref("Заявка на подписку: Клуб Опцыон LAFT");

      ElMessageBox.confirm(msg.value, "Внимание", {
        confirmButtonText: "Отправить",
        cancelButtonText: "Отменить",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "SAEcancelB",
        confirmButtonClass: "SAEconfirmB",
        //  type: 'warning',
      })
        .then(() => {
          let accounts = store.GetAllAccountsToString();

          let body =
            "Заявка на подписку: Клуб Опцыон LAFT" +
            "\n\r ЛК " +
            store.serverConf[store.currentServer].name +
            "\n\r e@mail: " +
            store.userInfo.value.Roles.email +
            "\n\r  счета клиента: " +
            accounts +
            "\n\r Имя Фамилия: " +
            fio.value +
            "\n\r Имя Telegram @: " +
            tele.value +
            "\n\r Комментарий: " +
            com.value;
          let data = {
            To: "client@ae.exchange",
            Subject: "Заявка на подписку: Клуб Опцыон LAFT",
            Body: body,
          };
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + store.token.value;
          axios
            .post(store.ServerUrl + "/users/sendtelegram", data)
            .then(function (resp) {
              console.log(resp);
            })
            .catch(function (err) {
              console.log(err);
            });
          ElMessage({
            type: "success",
            message: "Заявка отправлена",
          });
        })
        .catch(() => {
          disabledButton.value = false;
          ElMessage({
            type: "error",
            message: "Заявка отменена",
          });
        });
    };
    return {
      disabledButton,
      Send,
      fio,
      tele,
      com,
    };
  },
});
</script>
<style lang="scss">
.SAEcancelB {
  border: 1px solid #e82862 !important;
  border-radius: 0px !important;
  color: #e82862 !important;
}
.SAEconfirmB {
  border: 1px solid #e82862 !important;
  border-radius: 0px !important;
  background-color: #e82862 !important;
  color: white !important;
}
#club {
  font-size: 20px;
  line-height: 28px;
  .club_context {
    margin-top: 20px;
    border: 1px #d4d9dd solid;
    padding: 11px 18px;
    border-radius: 3px;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  }

}
.marker_row{
  list-style-image: url(~@/assets/images/arrow-right.svg);
    font-size: 20px;
    margin-bottom: 5px;
}
</style>
